import { render, staticRenderFns } from "./create-member-dialog.vue?vue&type=template&id=878c07b4&scoped=true&"
import script from "./create-member-dialog.vue?vue&type=script&lang=ts&"
export * from "./create-member-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./create-member-dialog.vue?vue&type=style&index=0&id=878c07b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878c07b4",
  null
  
)

export default component.exports